console.log("Iurop functions")

function applyDynamicMargin() {
  const sources = document.querySelectorAll('.section-featured-collection-products');

  sources.forEach((source, index) => {
    const el = source;
    const leftDistance = el.getBoundingClientRect().left;
  });
}

let resizeTimeout;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    applyDynamicMargin();
  }, 150);
});


function applyDynamicSizes() {
  const allPacks = document.querySelector('.kaching-bundles__bars');
  const selectedPack = document.querySelector('.kaching-bundles__bars .kaching-bundles__bar.kaching-bundles__bar--selected');

  if (!allPacks) return;

  if (selectedPack) {
    const indexSelected = Array.from(allPacks.children).indexOf(selectedPack);

    allPacks.classList.remove('is-one-product')
    allPacks.classList.remove('is-two-products')
    allPacks.classList.remove('is-three-products')

    if (indexSelected == 0) {
      allPacks.classList.add('is-one-product')
    }
    if (indexSelected == 1) {
      allPacks.classList.add('is-two-products')
    }
    if (indexSelected == 3) {
      allPacks.classList.add('is-three-products')
    }
    console.log("Selected pack!", selectedPack, indexSelected)
  }

}

function normalizeTitle(text) {
  if (!text) return '';
  return text.replace(/\uFE0F/g, '').trim();
}

function formatSelectedValues(value1, value2) {
  const values = [value1, value2].filter((value) => value && value !== 'false');
  return values.join(' - ');
}

function sanitizeCollectionText() {
  const titleEls = document.querySelectorAll('.grid-product__title');
  titleEls.forEach((el) => {
    const original = el.textContent || '';
    const cleaned = normalizeTitle(original)
      .replace(/\s*\|\s*false\s*-\s*false/gi, '')
      .replace(/false\s*-\s*false/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();

    if (cleaned && cleaned !== original.trim()) {
      el.textContent = cleaned;
    }
  });
}

function updateBundleVariantTitles() {
  if (!document.querySelector('.h2.product-single__title')) return;

  const productTitleEl = document.querySelector('.h2.product-single__title');
  const titleBase = normalizeTitle(productTitleEl.textContent || '').split('®')[0].trim();
  const selectors = document.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper');

  if (!selectors.length) return;

  for (let i = 0; i < selectors.length; i++) {
    const selector = selectors[i];
    const optionGroups = selector.querySelectorAll('.kaching-bundles__swatch-buttons.kaching-bundles-option');
    let value1 = '';
    let value2 = '';

    if (optionGroups[0]) {
      const selected = optionGroups[0].querySelector('.kaching-bundles__swatch-buttons__button--selected');
      value1 = selected ? selected.getAttribute('data-value') : '';
    }

    if (optionGroups[1]) {
      const selected = optionGroups[1].querySelector('.kaching-bundles__swatch-buttons__button--selected');
      value2 = selected ? selected.getAttribute('data-value') : '';
    }

    const numberEl = selector.querySelector('.kaching-bundles__bar-variant-number');
    if (!numberEl) continue;

    const selectedValues = formatSelectedValues(value1, value2);
    const selectedMarkup = selectedValues ? `<span class="selecteds">${selectedValues}</span>` : '';
    numberEl.innerHTML = `<span>${titleBase}</span>${selectedMarkup}`;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  applyDynamicMargin();
  applyDynamicSizes();
  sanitizeCollectionText();


  setTimeout(() => {
    const filterGroupPrice = document.querySelector('.filter-form div[data-collapsible-id="filter-precio"]')
    if (filterGroupPrice) {
      const trigger = filterGroupPrice.closest('.collection-sidebar__group').querySelector('.collapsible-trigger-btn')

      if (trigger) trigger.click()
    }

    const navMobile = document.querySelector('.site-nav__icons')
    if (navMobile) {
      navMobile.classList.add('show-nav')
    }
    
  }, 1300);

  setInterval(() => {
    const widgetReviews = document.querySelector(".template-index .loox-trust-badge-container.loox-widget");
    const targetContainer = document.querySelector(".template-index .hero__text-wrap .hero__subtitle");

    const alreadyMove = document.querySelector(".template-index .hero__text-wrap .hero__subtitle .loox-widget");

    if (widgetReviews && !alreadyMove) {
      targetContainer.appendChild(widgetReviews);
    }

    updateBundleVariantTitles();
    sanitizeCollectionText();


  }, 1000);

  document.querySelector('.close-drawer-header').addEventListener('click', () => {
    location.reload();
  });

  document.addEventListener('change', function(e) {
    if (e.target.id === 'secure-shipping') {
      const isChecked = e.target.checked;
      const addSecureShippButton = e.target.closest('.cart-segure-shpping').querySelector('.quick-add-secure-shipping button')

      if (isChecked) {
        console.log("Add", addSecureShippButton)

        if (addSecureShippButton) {
          addSecureShippButton.click()
        }
      } else {
        console.log("Rermove")
        const removeSecureButton = e.target.closest('.cart__scrollable').querySelector('.cart__item.is-secure-item .js-qty__num')
        if (removeSecureButton) {
          removeSecureButton.value = 0;

          removeSecureButton.dispatchEvent(new Event('input', { bubbles: true }));
          removeSecureButton.dispatchEvent(new Event('change', { bubbles: true }));

        }
      }
    }
  });

});
